// import { useState, useEffect } from "react";

const UserNameFormat = (name) => {
  let tempName = name;
  if (name.length > 15) tempName = `${name.slice(0, 15)}...`;
  return tempName;
};
export default UserNameFormat;
